import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { createI18n } from 'vue-i18n'

if (location.hostname == 'service.three-villages.com') {
	axios.defaults.baseURL = 'https://api.three-villages.com'
	axios.defaults.headers.common['Access-Control-Allow-Origin'] = 'https://api.three-villages.com'
} else if (location.hostname == 'develop-service.three-villages.com') {
	axios.defaults.baseURL = 'https://develop-api.three-villages.com'
	axios.defaults.headers.common['Access-Control-Allow-Origin'] = 'https://develop-api.three-villages.com'
} else {
	axios.defaults.baseURL = 'http://127.0.0.1:8000'
	axios.defaults.headers.common['Access-Control-Allow-Origin'] = 'http://127.0.0.1:8000'
}
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.withCredentials = true
axios.interceptors.request.use(function (config) {
	if (store.getters.token) {
		axios.defaults.headers.common['Authorization'] = 'Token ' + store.getters.token
		config.headers.Authorization = 'Token ' + store.getters.token
		//console.log('comp_cd=' + store.getters.comp_cd)
		if (store.getters.comp_cd) {
			config.params = {
				'comp_cd' : store.getters.comp_cd
			}
		}
	} else {
		axios.defaults.headers.common['Authorization'] = ''
		config.headers.Authorization = ''
	}
	return config
}, function (error) {
	return Promise.reject(error)
})

const data = require('./message.json');

const i18n = createI18n({
	legacy: false,
	locale: 'ja',
	fallbackLocale: "en",
	messages: data
})

createApp(App).use(store).use(router, axios).use(i18n).mount('#app')
